import * as React from "react";
import { useEffect, useState, useMemo, useCallback } from "react";
import { useDataProvider } from "react-admin";
import useAiInsight from "../../../Components/AiAssistant/useAiInsight";
import { buildAiBaseParams } from "../../../Components/AiAssistant/buildAiBaseParams";
import { Button, Dialog, DialogContent, Typography } from "@material-ui/core";
import GaugeChart from "../../../Components/CustomChart/GaugeChart";
import { ViewList } from "@material-ui/icons";
import CockpitResponseTimeViewList from "./CockpitResponseTimeViewList";

const CockpitResponseTime = ({ filterParams }) => {
  const dataProvider = useDataProvider();

  const [chartData, setChartData] = useState([] as any);
  const [chartValue, setChartValue] = useState(0);
  const [open, setOpen] = useState(false);

  const resourceEndpoint = "pbhrequestorders/cockpit/responsetime";

  const subArcs = [
    {
      limit: 20,
      color: "#5BE12C",
      showTick: true,
    },
    {
      limit: 40,
      color: "#FFC700",
      showTick: true,
    },
    {
      limit: 60,
      color: "#FF7A00",
      showTick: true,
    },
    {
      limit: 120,
      color: "#EA4228",
      showTick: true,
    },
  ];

  const insightParams = useMemo(() => {
    if (!chartData.length) return null;
    const withinTargetCount = chartData.filter((d: any) => d.responseTime <= 20).length;
    const withinTargetRate = ((withinTargetCount / chartData.length) * 100).toFixed(1) + "%";
    return {
      ...buildAiBaseParams(filterParams),
      avgResponseTimeMins: chartValue.toFixed(2),
      requestCount: chartData.length.toString(),
      withinTargetCount: withinTargetCount.toString(),
      withinTargetRate,
    };
  }, [filterParams, chartValue, chartData]);
  useAiInsight("cockpitresponsetime", insightParams);

  const GetChartData = useCallback(async () => {
    await dataProvider
      .getList(resourceEndpoint, {
        pagination: { page: 1, perPage: 999999 },
        sort: { field: "id", order: "ASC" },
        filter: { ...filterParams, isException__neq: true },
      })
      .then(({ data }) => {
        const sum = data.reduce((sum, current) => sum + current.responseTime, 0);
        const avg = Number(sum / data.length);
        setChartData(data);
        setChartValue(avg);
      })
      .catch(error => {
        console.log(error);
      });
  }, [filterParams, dataProvider]);

  useEffect(() => {
    GetChartData();
  }, [GetChartData]);

  return (
    <>
      <Typography gutterBottom variant="h5" component="h2" align="center">
        Response Time (min)
      </Typography>
      <GaugeChart value={chartValue} subArcs={subArcs} maxValue={120} formatTextValue="" />
      <Button fullWidth startIcon={<ViewList />} onClick={() => setOpen(true)} color="primary">
        View
      </Button>
      <Dialog
        fullWidth={true}
        maxWidth={"lg"}
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="max-width-dialog-title"
      >
        <DialogContent>
          <CockpitResponseTimeViewList
            filterParams={filterParams}
            resource={resourceEndpoint}
            basePath={resourceEndpoint}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CockpitResponseTime;
